import Common from "@/common";
import { mapGetters, mapMutations } from "vuex";
import alertHelper from "@/helper/AlertHelper";

export const paymentInformationMixin = {
  data() {
    return {
      passwordRequestTimerDuration: 180000,
      transactionTimerDuration: 300000,
      shaparakRegisterModalShow: false,
      captchaValidationModalShow: false,
      minutesTimerCounter: 5,
      creditCardInfo: [
        { length: 4, value: "" },
        { length: 4, value: "" },
        { length: 4, value: "" },
        { length: 4, value: "" },
      ],
      creditCardPassword: "",
      creditCardCVV2: "",
      creditCardExpireDateMonth: "",
      creditCardExpireDateYear: "",
      creditCardExpireDateConcated: "",
      securityCode: "",
      passwordRequestSend: false,
      passwordRequestResend: false,
      email: "",
      paymentId: "",
      querySecret: "",
      checkUrl: "",
      checkTxStatusInterval: null,
      saveCardInfo: false,
      passwordRequestPending: false,
      isCardInfoSavedBefore: false,
      bankImageSource: "",
      checkIfInputNotEmpty: false,
      nationalCode: "",
      // Card Enrollment Modal Data
      cardEnrollmentRequestPending: false,
      cardEnrollmentOTPCode: "",
      cardEnrollmentExpireDateYear: "",
      cardEnrollmentExpireDateMonth: "",
      captchaKey: null,
      captchaImageBase64: null,
      captchaAudioUrl: null,
      multiImageCaptchaInfo: null,
    };
  },

  watch: {
    // Auto Focus (Auto Tab) When The Fields Are Full
    creditCardExpireDateMonth(value) {
      if (value.length === 2) {
        document.getElementById("expireDateYearInput").focus();
      }
    },
    creditCardExpireDateYear(value) {
      if (value.length === 2) {
        document.getElementById("creditCardPasswordInput").focus();
      }
    },
    creditCardCVV2(value) {
      if (value.length === 4) {
        document.getElementById("expireDateMonthInput").focus();
      }
    },
    // /Auto Focus (Auto Tab) When The Fields Are Full
  },
  methods: {
    ...mapMutations([
      "setPaymentSuccess",
      "setCallBackUrl",
      "setRefNumber",
      "setTransactionCompleteTime",
      "setStepperPage",
      "setCreditCardInfoIfCode6666",
    ]),
    transactionFailedAction() {
      this.setPaymentSuccess(false);
      this.$router.push(
        `/shetab/final?id=${this.paymentId}&s=${this.querySecret}`
      );
    },
    timerExpiredAlert() {
      const expiredAlertMsg = "مدت زمان پرداخت 5 دقیقه میباشد";
      const fixErrorMessage =
        "<strong>لطفا پرداخت خود را با سوییچ دیگری که به آن هدایت می شوید، امتحان کنید</strong>";
      this.$swal({
        title: "توجه",
        html: expiredAlertMsg + "، " + fixErrorMessage,
        icon: "danger",
        showConfirmButton: true,
        allowOutsideClick: false,
        confirmButtonText: "متوجه شدم",
        preConfirm: () => {
          this.activateNewSwitch();
        },
        customClass: {
          title: "alertTitleClass",
        },
      });
    },

    expiredTransactionTimerAction() {
      this.transactionFailedAction();
      this.timerExpiredAlert();
    },
    expiredPasswordRequestAction() {
      this.passwordRequestSend = false;
    },
    cancelPayment() {
      this.setPaymentSuccess(false);
      alertHelper.loadingAlert();
      const callBackUrl = this.getCallBackUrl;
      if (callBackUrl) {
        window.location.href = Common.createCallback(
          callBackUrl,
          this.paymentId,
          0
        );
      } else {
        this.$http.delete(`payments/${this.paymentId}`).then(
          (result) => {
            window.location.href = Common.createCallback(
              result.data.data.callback_url,
              this.paymentId,
              0
            );
          },
          (error) => {
            alertHelper.apiErrorAlert("", error.body.message);
          }
        );
      }
    },
    storeCardInfo() {
      const cardInfo = {
        cvv2: this.creditCardCVV2,
        expireMonth: this.creditCardExpireDateMonth,
        expireYear: this.creditCardExpireDateYear,
      };
      this.setCreditCardInfoIfCode6666(cardInfo);
    },

    //Submit Information
    finalTransferSubmit() {
      this.creditCardExpireDateConcated = this.creditCardExpireDateYear.concat(
        this.creditCardExpireDateMonth
      );
      /* if(!this.getNationalCodeNeeded){
        this.nationalCode = null;
      }
      if(this.getNationalCodeNeeded){
        if(this.nationalCode.length != 10){
          this.$swal.fire({
            icon: 'error',
            showConfirmButton: false,
            timer: 1500,
            text: 'لطفا تمامی فیلد ها به درستی را پر کنید'
          });
        }
      } */
      if (
        this.creditCardExpireDateConcated.length < 4 ||
        this.creditCardPassword === "" ||
        this.creditCardCVV2 === "" ||
        this.creditCardExpireDateMonth > 12
      ) {
        alertHelper.errorAlert("", "لطفا تمامی فیلد ها را به درستی پر کنید");
      } else {
        alertHelper.loadingAlert(
          "لطفا منتظر بمانید و تا زمان مشخص شدن نتیجه تراکنش، این صفحه را رفرش نکنید"
        );
        let transactionId = this.getTransactionId;
        this.$http
          .post(`shetab/${transactionId}/final-transfer`, {
            pin_code: this.creditCardPassword,
            cvv2_code: this.creditCardCVV2,
            exp_date: this.creditCardExpireDateConcated,
            nationalCode: this.nationalCode,
          })
          .then(
            (result) => {
              if (result.data.data && result.data.data.check_url) {
                this.setCallBackUrl(result.data.data.payment.callback_url);
                this.checkUrl = result.data.data.check_url;
                this.startCheckingTxResult();
              }
            },
            (error) => {
              //Open the shaparak modal register
              if (
                error.body &&
                error.body.additional_info &&
                error.body.additional_info.code
              ) {
                if (error.body.additional_info.code === 7777) {
                  alertHelper.closeAlert();
                  this.shaparakRegisterModalShow = true;
                } else if (error.body.additional_info.code === 8888) {
                  alertHelper.closeAlert();
                  // this.captchaImageBase64 = error.body.additional_info.message;

                  // this.captchaAudioUrl = error.body.additional_info.message;

                  this.multiImageCaptchaInfo = error.body.additional_info;
                  this.captchaValidationModalShow = true;
                } else if (error.body.additional_info.code === 6666) {
                  alertHelper.closeAlert();
                  this.storeCardInfo();
                  this.$router.push(
                    `/shetab/validation?id=${this.paymentId}&s=${this.querySecret}`
                  );
                } else {
                  alertHelper.apiErrorAlert();
                }
              } else {
                this.hardErrorAlertHandler("", error.body.message);
                this.transactionFailedAction();
              }
            }
          );
      }
    },

    activateNewSwitch() {
      this.$router.push(`/?id=${this.paymentId}&s=${this.querySecret}`);
    },
    hardErrorAlertHandler(title, msg) {
      alertHelper.hardErrorAlert(title, msg).then(() => {
        this.activateNewSwitch();
      });
    },
    startCheckingTxResult() {
      this.checkTxStatusInterval = setInterval(() => {
        this.$http.get(this.checkUrl).then(
          (result) => {
            if (
              result.data.data &&
              result.data.data.status !== "PENDING_GATEWAY" &&
              result.data.data.status !== "IN_GATEWAY"
            ) {
              if (result.data.data.status === "SUCCESS") {
                clearInterval(this.checkTxStatusInterval);
                alertHelper.successAlert();
                this.setRefNumber(
                  result.data.data.shetab_result.transfer.refNumber
                );
                this.setTransactionCompleteTime(
                  result.data.data.shetab_result.transfer.transferTime
                );
                this.setPaymentSuccess(true);
                if (this.saveCardInfo) {
                  if (!localStorage?.getItem("saveCardInfo")) {
                    localStorage?.setItem(
                      "saveCardInfo",
                      JSON.stringify({
                        cardNumber: this.getCompleteCreditCardNumber,
                        expDate: this.creditCardExpireDateConcated,
                      })
                    );
                  } else {
                    try {
                      let savedCards = localStorage?.getItem("saveCardInfo")
                        ? localStorage?.getItem("saveCardInfo").split("-")
                        : [];
                      for (let eachCardInfo of savedCards) {
                        let translatedCardInfo = JSON.parse(eachCardInfo);
                        if (
                          translatedCardInfo.cardNumber ===
                          this.getCompleteCreditCardNumber
                        ) {
                          this.isCardInfoSavedBefore = true;
                          break;
                        } else {
                          this.isCardInfoSavedBefore = false;
                        }
                      }
                      if (this.isCardInfoSavedBefore === false) {
                        localStorage?.setItem(
                          "saveCardInfo",
                          localStorage?.getItem("saveCardInfo") +
                            "-" +
                            JSON.stringify({
                              cardNumber: this.getCompleteCreditCardNumber,
                              expDate: this.creditCardExpireDateConcated,
                            })
                        );
                      }
                    } catch (e) {
                      console.log(
                        "error occured on saving card data in local storage"
                      );
                      this.$router.push(
                        `/shetab/final?id=${this.paymentId}&s=${this.querySecret}`
                      );
                    }
                  }
                }
                this.$router.push(
                  `/shetab/final?id=${this.paymentId}&s=${this.querySecret}`
                );
              } else if (result.data.data.status === "FAILED") {
                clearInterval(this.checkTxStatusInterval);
                if (
                  result.data.data &&
                  result.data.data.shetab_result &&
                  result.data.data.shetab_result.status
                ) {
                  if (result.data.data.shetab_result.code === 7777) {
                    this.shaparakRegisterModalShow = true;
                    alertHelper.closeAlert();
                  } else if (result.data.data.shetab_result.code === 8888) {
                    alertHelper.closeAlert();
                    // this.captchaImageBase64 =
                    //   result.data.data.shetab_result.message;
                    // this.captchaAudioUrl =
                    //   result.data.data.shetab_result.message;

                    this.multiImageCaptchaInfo =
                      result.data.data.shetab_result;

                    this.captchaValidationModalShow = true;
                  } else if (result.data.data.shetab_result.code === 6666) {
                    alertHelper.closeAlert();
                    this.storeCardInfo();
                    this.$router.push(
                      `/shetab/validation?id=${this.paymentId}&s=${this.querySecret}`
                    );
                  } else {
                    this.hardErrorAlertHandler(
                      "",
                      result.data.data.shetab_result.userMessage
                    );
                    this.transactionFailedAction();
                  }
                }
              } else {
                this.hardErrorAlertHandler();
                this.transactionFailedAction();
              }
            }
          },
          (error) => {
            // clearInterval(this.checkTxStatusInterval);
            /*this.$swal.fire({
              icon: 'error',
              showConfirmButton: true,
              timer: 10000,
              confirmButtonText: 'متوجه شدم',
              text: error.body.message,
            });
            this.$store.state.paymentSuccess = false;
            this.$router.push('/shetab/final?id=' + this.paymentId);*/
            console.log(error);
          }
        );
      }, 4000);
    },
    getCreditCardNum() {
      for (let i = 0; i < this.creditCardInfo.length; i++) {
        this.creditCardInfo[i].value = this.getCreditCardInfo[i];
      }
    },
    checkIfDataIsLost() {
      if (this.getCreditCardInfo.length < 4)
        this.$router.push(`/?id=${this.paymentId}&s=${this.querySecret}`);
      else this.showStartingAlert();
    },
    activateTimerEvent(key) {
      setTimeout(() => {
        if (this.$refs[key]) this.$refs[key].activeInterval();
      }, 1);
    },
    deactivateTimerEvent(key) {
      setTimeout(() => {
        if (this.$refs[key]) this.$refs[key].clearInterval();
      }, 1);
    },
    deactivateTimers() {
      this.deactivateTimerEvent("PasswordRequest");
      this.deactivateTimerEvent("Transaction");
    },
    getCreditCardPass() {
      this.passwordRequestPending = true;

      const creditCardExp = this.creditCardExpireDateYear.concat(
        this.creditCardExpireDateMonth
      );

      // adding the api body is optional
      let apiBody = {};
      if (
        creditCardExp?.length === 4 &&
        this.creditCardCVV2?.length > 2 &&
        this.creditCardMonthExpireValidation
      ) {
        apiBody = {
          cvv2: this.creditCardCVV2,
          exp: creditCardExp,
        };
      }

      this.$http
        .post(`transactions/${this.getTransactionId}/request-pin`, apiBody)
        .then(
          (result) => {
            if (result.status === 200) {
              alertHelper.successAlert(
                "",
                "درخواست شما برای بانک صادر کننده ارسال شد",
                1500
              );
              this.passwordRequestPending = false;
              this.passwordRequestSend = true;
              this.activateTimerEvent("PasswordRequest");
              // this.activePasswordRequestTimer();
            }
          },
          (error) => {
            this.deactivateTimerEvent("PasswordRequest");
            this.passwordRequestSend = false;
            this.passwordRequestPending = false;
            //Open the shaparak modal register
            if (
              error.body &&
              error.body.additional_info &&
              error.body.additional_info.code
            ) {
              if (error.body.additional_info.code === 7777) {
                alertHelper.closeAlert();
                this.shaparakRegisterModalShow = true;
              } else if (error.body.additional_info.code === 8888) {
                alertHelper.closeAlert();
                /*this.captchaImageBase64 = error.body.additional_info.message;
                this.captchaValidationModalShow = true;*/
                // this.captchaAudioUrl = error.body.additional_info.message;

                this.multiImageCaptchaInfo = error.body.additional_info;
                this.captchaValidationModalShow = true;
              } else if (error.body.additional_info.code === 6666) {
                alertHelper.closeAlert();
                this.storeCardInfo();
                this.$router.push(
                  `/shetab/validation?id=${this.paymentId}&s=${this.querySecret}`
                );
              } else {
                // alertHelper.apiErrorAlert();
                this.handleRequestPinCodeErrorAlert(error.body.message);
              }
            } else {
              this.handleRequestPinCodeErrorAlert(error.body.message);
              // alertHelper
              //   .apiErrorAlert("", error.body.message, 20000, "تلاش مجدد")
              //   .then((result) => {
              //     if (result.isConfirmed) {
              //       this.activateNewSwitch();
              //     }
              //   });
            }
          }
        );
      // this.$router.push('/PaymentInformation' + "/" + paymentId);
    },
    handleRequestPinCodeErrorAlert(message) {
      let alertMessage = message ? message : "";
      if (message === "Timeout") alertMessage = "اختلال شبکه بانکی";
      alertHelper
        .requestPinCodeErrorAlert(
          "",
          alertMessage,
          20000,
          "سوییچ جدید",
          "تلاش مجدد"
        )
        .then((result) => {
          if (result.isConfirmed) {
            this.activateNewSwitch();
          } else if (result.isDismissed && result.dismiss === "cancel") {
            this.getCreditCardPass();
          }
        });
    },
    checkIfSavedCardSelected() {
      if (this.getSavedCardExpDate !== "") {
        this.creditCardExpireDateYear = this.getSavedCardExpDate.slice(0, 2);
        this.creditCardExpireDateMonth = this.getSavedCardExpDate.slice(2, 4);
      }
    },
    setCardInfoIfStored() {
      this.creditCardCVV2 = this.getCreditCardInfoIfCode6666.cvv2;
      this.creditCardExpireDateMonth =
        this.getCreditCardInfoIfCode6666.expireMonth;
      this.creditCardExpireDateYear =
        this.getCreditCardInfoIfCode6666.expireYear;
    },
    showStartingAlert() {
      let paymentId = this.$route.query.id;
      if (paymentId) {
        if (this.getVersion === "v1") {
          alertHelper.shetabStartingAlert();
        }
      } else {
        alertHelper.transactionNotValidAlert();
      }
    },
  },
  computed: {
    ...mapGetters([
      "getCreditCardInfo",
      "getTransactionId",
      "getShetabSelectedPayingAmount",
      "getCompleteCreditCardNumber",
      "getSavedCardExpDate",
      "getNationalCodeNeeded",
      "getVersion",
      "getCreditCardInfoIfCode6666",
      "getCallBackUrl",
    ]),
    creditCardMonthExpireValidation() {
      return (
        this.creditCardExpireDateMonth <= 12 &&
        this.creditCardExpireDateMonth.length === 2 &&
        this.creditCardExpireDateYear.length === 2
      );
    },
  },
  created() {
    this.paymentId = this.$route.query.id;
    this.querySecret = this.$route.query.s;
    this.setStepperPage("pageThree");
    this.getCreditCardNum();
    this.checkIfDataIsLost();
    [this.checkIfInputNotEmpty, this.bankImageSource] = Common.checkWhatBank(
      this.creditCardInfo
    );
    //first check the vuex for info
    this.setCardInfoIfStored();
    //second check the local storage.
    this.checkIfSavedCardSelected();
  },
  mounted() {
    this.activateTimerEvent("Transaction");
  },
  destroyed() {
    this.deactivateTimers();
  },
};
